import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { CSSProperties } from 'react';
import { useTranslation } from 'react-i18next';

import { IOrganization } from '../../../interfaces';
import { ETranslation } from '../../../translations/translation-keys';
import Table from '../../UI/Table/Table';
import TableTh from '../../UI/Table/TableTh/TableTh';
import { useTableSort } from '../../UI/Table/useTableSort';
import classes from './ServiceProvidersTable.module.scss';

interface IProps {
  serviceproviders: Array<IOrganization>
  statusProp?: string;
  onClick: (event: React.MouseEvent<HTMLTableRowElement>, id: string) => void;
  sortable?: boolean;
  containerClassName?: string;
  containerStyle?: CSSProperties;
  isPrimary?: boolean;
}

const ServiceProviderTable: React.FC<IProps> = ({ serviceproviders, statusProp, onClick, sortable, containerClassName, containerStyle, isPrimary }) => {
  const { t } = useTranslation();
  const { sort, onSort, items: sortedServiceProviders } = useTableSort({ data: serviceproviders });

  return (
    <div className={containerClassName} style={containerStyle}>
      <Table hover sortContext={{ sort, onSort }}>
        <thead>
          <tr className={classes.TableHeader}>
            {statusProp}
            {sortable ? (
              <>
                <TableTh sort="name">{t(ETranslation.OPERATOR_NAME)}</TableTh>
                <TableTh sort="businessId">{t(ETranslation.OPERATOR_BUSINESS_ID)}</TableTh>
                <th>{t(ETranslation.OFFERREQUEST_ADDRESS)}</th>
                <TableTh sort="zip">{t(ETranslation.COMMON_ZIP)}</TableTh>
                <th>{t(ETranslation.COMMON_CITY)}</th>
                <th>{t(ETranslation.COMMON_COUNTRY)}</th>
                <th>{t(ETranslation.SERVICES)}</th>
                <th>{t(ETranslation.LOCATIONS)}</th>
                {isPrimary && <th>{t(ETranslation.COMMON_OPERATOR_NAME)}</th>}
                <th>{t(ETranslation.COMMON_ARCHIVED)}</th>
              </>
            ) : (
              <>
                <th>{t(ETranslation.OPERATOR_NAME)}</th>
                <th>{t(ETranslation.OPERATOR_BUSINESS_ID)}</th>
                <th>{t(ETranslation.COMMON_STREET_ADDRESS)}</th>
                <th>{t(ETranslation.COMMON_ZIP)}</th>
                <th>{t(ETranslation.COMMON_CITY)}</th>
                <th>{t(ETranslation.COMMON_COUNTRY)}</th>
                <th>{t(ETranslation.SERVICES)}</th>
                <th>{t(ETranslation.LOCATIONS)}</th>
                {isPrimary && <th>{t(ETranslation.COMMON_OPERATOR_NAME)}</th>}
                <th>{t(ETranslation.COMMON_ARCHIVED)}</th>
              </>
            )}
          </tr>
        </thead>
        <tbody>
          {sortedServiceProviders.map(serviceProvider => (
            <tr key={serviceProvider.id} onClick={(e) => onClick(e, serviceProvider.id)}>
              <td>{serviceProvider.name}</td>
              <td>{serviceProvider.businessId}</td>
              <td>{serviceProvider.streetAddress}</td>
              <td>{serviceProvider.zip}</td>
              <td>{serviceProvider.city}</td>
              <td>{serviceProvider.countryCode}</td>
              <td>{serviceProvider.services?.map(s => s.name).join(", ")}</td>
              <td>{serviceProvider.locations?.map(l => l.name).join(", ")}</td>
              {isPrimary && <td>{serviceProvider.parent?.name}</td>}
              <td>{serviceProvider.archived ? <FontAwesomeIcon icon={faCheck} /> : null}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default ServiceProviderTable;
